import React, { useState } from 'react'
import NavbarOne from './separate/NavbarOne'
import Footer from './separate/Footer'
import {
  LuRocket,
  LuUsers,
  LuShield,
  LuGlobe,
  LuLaptop,
  LuHeart,
  LuCoffee,
  LuAward,
  LuZap,
  LuMapPin,
  LuClock,
  LuChevronRight,
  LuArrowRight,
} from 'react-icons/lu'
import { useNavigate } from 'react-router-dom'
import PageTitleDes from '../core/support/PageTitleDes'

const values = [
  {
    icon: LuRocket,
    title: 'Innovation First',
    description:
      'We push boundaries and challenge the status quo to build the future of finance.',
  },
  {
    icon: LuUsers,
    title: 'Team Spirit',
    description:
      "Collaboration is at our core. We win together and support each other's growth.",
  },
  {
    icon: LuShield,
    title: 'Trust & Security',
    description:
      'We prioritize security in everything we build, earning trust through transparency.',
  },
  {
    icon: LuGlobe,
    title: 'Global Impact',
    description:
      'Our work reaches millions worldwide, breaking barriers in financial access.',
  },
]

const benefits = [
  {
    icon: LuLaptop,
    title: 'Remote First',
    description: 'Work from anywhere in the world',
  },
  {
    icon: LuHeart,
    title: 'Health & Wellness',
    description: 'Comprehensive health coverage',
  },
  {
    icon: LuCoffee,
    title: 'Unlimited PTO',
    description: 'Take time when you need it',
  },
  {
    icon: LuAward,
    title: 'Equity Options',
    description: 'Share in our success',
  },
  {
    icon: LuZap,
    title: 'Learning Budget',
    description: '$2,000 annual learning stipend',
  },
  {
    icon: LuGlobe,
    title: 'Team Retreats',
    description: 'Annual global team meetups',
  },
]

const openPositions = [
  {
    title: 'Senior Blockchain Engineer',
    department: 'Engineering',
    location: 'Remote',
    type: 'Full-time',
    tags: ['Solidity', 'Rust', 'Web3'],
  },
  {
    title: 'Product Designer',
    department: 'Design',
    location: 'Remote',
    type: 'Full-time',
    tags: ['Figma', 'UI/UX', 'Design Systems'],
  },
  {
    title: 'Senior Backend Engineer',
    department: 'Engineering',
    location: 'Remote',
    type: 'Full-time',
    tags: ['Node.js', 'PostgreSQL', 'Redis'],
  },
  {
    title: 'Security Engineer',
    department: 'Security',
    location: 'Remote',
    type: 'Full-time',
    tags: ['Penetration Testing', 'Smart Contracts', 'Auditing'],
  },
  {
    title: 'Growth Marketing Manager',
    department: 'Marketing',
    location: 'Remote',
    type: 'Full-time',
    tags: ['SEO', 'Paid Ads', 'Analytics'],
  },
  {
    title: 'Customer Success Lead',
    department: 'Operations',
    location: 'Remote',
    type: 'Full-time',
    tags: ['Support', 'Onboarding', 'Retention'],
  },
]

const stats = [
  { value: 'Growing', label: 'Team' },
  { value: 'Global', label: 'Presence' },
  { value: 'Expanding', label: 'User Base' },
  { value: '24/7', label: 'Platform' },
]

function Career() {
  const [hoveredIndex, setHoveredIndex] = useState(null)
  const navigate = useNavigate()

  return (
    <div
      className='bg-default text-white'
      style={{ overflowX: 'hidden', backgroundColor: '#0B0E14' }}
    >
      <PageTitleDes title={`Careers at Unitic Exchange | Join Our Crypto Team`} description={`Explore career opportunities at Unitic Exchange. Join our growing team and build your future in the cryptocurrency industry.`} />
      <NavbarOne />

      {/* Styles for animations */}
      <style>
        {`
          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
            100% { transform: translateY(0px); }
          }
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-float {
            animation: float 6s ease-in-out infinite;
          }
          .animate-pulse {
            animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
          }
          .animate-fade-in {
            animation: fadeIn 0.8s ease-out forwards;
          }
          .hover-card:hover {
            border-color: rgba(29, 160, 148, 0.5) !important;
            box-shadow: 0 0 40px rgba(29, 160, 148, 0.15);
            transform: translateY(-5px);
          }
        `}
      </style>

      {/* Hero Section */}
      <section
        className='position-relative d-flex align-items-center justify-content-center py-5'
        style={{ minHeight: 'calc(100vh - 10px)', overflow: 'hidden' }}
      >
        {/* Animated Background */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'linear-gradient(to bottom, rgba(29, 160, 148, 0.1), #0B0E14)',
            zIndex: 0,
          }}
        />
        {/* Blobs */}
        <div
          className='animate-pulse'
          style={{
            position: 'absolute',
            top: '25%',
            left: '25%',
            width: '600px',
            height: '600px',
            background: 'rgba(29, 160, 148, 0.2)',
            borderRadius: '50%',
            filter: 'blur(150px)',
            zIndex: 0,
          }}
        />
        <div
          className='animate-pulse'
          style={{
            position: 'absolute',
            bottom: '25%',
            right: '25%',
            width: '500px',
            height: '500px',
            background: 'rgba(29, 160, 148, 0.15)',
            borderRadius: '50%',
            filter: 'blur(120px)',
            zIndex: 0,
            animationDelay: '1s',
          }}
        />

        {/* Floating Elements */}
        <div
          className='animate-float'
          style={{
            position: 'absolute',
            top: '33%',
            left: '10%',
            width: '80px',
            height: '80px',
            border: '1px solid rgba(29, 160, 148, 0.2)',
            borderRadius: '16px',
            transform: 'rotate(12deg)',
            opacity: 0.3,
            zIndex: 0,
          }}
        />
        <div
          className='animate-float'
          style={{
            position: 'absolute',
            top: '50%',
            right: '15%',
            width: '64px',
            height: '64px',
            border: '1px solid rgba(29, 160, 148, 0.3)',
            borderRadius: '50%',
            opacity: 0.4,
            animationDelay: '1s',
            zIndex: 0,
          }}
        />
        <div
          className='animate-float'
          style={{
            position: 'absolute',
            bottom: '33%',
            left: '20%',
            width: '48px',
            height: '48px',
            background: 'rgba(29, 160, 148, 0.1)',
            borderRadius: '12px',
            opacity: 0.5,
            animationDelay: '2s',
            zIndex: 0,
          }}
        />

        <div className='container position-relative z-1 text-center pt-5'>
          <div
            className='d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill mb-4 animate-fade-in'
            style={{
              background: 'rgba(29, 160, 148, 0.05)',
              border: '1px solid rgba(29, 160, 148, 0.3)',
              backdropFilter: 'blur(4px)',
            }}
          >
            <span
              className='animate-pulse'
              style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: '#1da094',
              }}
            />
            <span
              style={{ color: '#1da094', fontSize: '14px', fontWeight: 500 }}
            >
              We're Hiring!
            </span>
          </div>
          <h1
            className='fw-bold mb-4 animate-fade-in display-4'
            style={{
              // fontSize: 'clamp(2.5rem, 6vw, 5rem)',
              lineHeight: 1.1,
              animationDelay: '0.1s',
            }}
          >
            <span>Build the Future of</span> <br />
            <span
              style={{
                background: 'linear-gradient(to right, #1da094, #34D399)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Global Finance
            </span>
          </h1>

          <p
            className='mx-auto mb-5 animate-fade-in fs-5'
            style={{
              color: '#9AA6B2',
              maxWidth: '800px',
              animationDelay: '0.2s',
            }}
          >
            Join a world-class team on a mission to make cryptocurrency
            accessible, secure, and simple for everyone.
          </p>

          <div
            className='d-flex flex-column flex-sm-row justify-content-center gap-3 mb-5 animate-fade-in'
            style={{ animationDelay: '0.3s' }}
          >
            <button
              className='btn-hero'
              onClick={() => {
                const el = document.getElementById("open-positions");
                if (el) {
                  const yOffset = -75;
                  const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                  window.scrollTo({ top: y, behavior: "smooth" });
                }
              }}
            >
              View Open Positions
              <LuArrowRight size={20} className='ms-2' />
            </button>
            <button
              onClick={() =>
                navigate('/about')
              }
              className='btn-hero-outline'
            >
              Learn About Us
            </button>
          </div>

          {/* Stats */}
          <div
            className='row g-4 mt-5 justify-content-center animate-fade-in'
            style={{ animationDelay: '0.4s' }}
          >
            {stats.map((stat, index) => (
              <div key={index} className='col-6 col-md-3'>
                <div
                  className='p-3 rounded-4'
                  style={{
                    background: 'rgba(255,255,255,0.03)',
                    border: '1px solid rgba(255,255,255,0.05)',
                    backdropFilter: 'blur(10px)',
                  }}
                >
                  <div
                    className='fw-bold mb-2 fs-3'
                    style={{ color: '#1da094' }}
                  >
                    {stat.value}
                  </div>
                  <div style={{ color: '#9AA6B2' }}>{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className='py-5 mb-5'>
        <div className='container'>
          <div className='text-center mb-5'>
            <h2 className='display-6 fw-bold mb-3'>
              Our <span style={{ color: '#1da094' }}>Values</span>
            </h2>
            <p
              className='text-muted-foreground mx-auto'
              style={{ color: '#9AA6B2' }}
            >
              The principles that guide everything we do
            </p>
          </div>

          <div className='row g-4'>
            {values.map((value, index) => (
              <div key={index} className='col-md-6 col-lg-3'>
                <div
                  className='h-100 p-4 rounded-4 hover-card animate-fade-in'
                  style={{
                    background: 'rgba(255,255,255,0.03)',
                    border: '1px solid rgba(255,255,255,0.05)',
                    transition: 'all 0.3s ease',
                    animationDelay: `${index * 0.1}s`,
                  }}
                >
                  <div
                    className='d-flex align-items-center justify-content-center mb-4'
                    style={{
                      width: '56px',
                      height: '56px',
                      borderRadius: '16px',
                      background: 'rgba(29, 160, 148, 0.1)',
                      color: '#1da094',
                      fontSize: '1.5rem',
                    }}
                  >
                    <value.icon />
                  </div>
                  <h3 className='h5 fw-bold mb-3'>{value.title}</h3>
                  <p style={{ color: '#9AA6B2' }}>{value.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Open Positions Section */}
      <section className='py-5 position-relative' id='open-positions'>
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'linear-gradient(to bottom, rgba(255,255,255,0.02), #0B0E14)',
            zIndex: 0,
          }}
        />
        <div className='container position-relative z-1'>
          <div className='text-center mb-5'>
            <h2 className='display-6 fw-bold mb-3'>
              Open <span style={{ color: '#1da094' }}>Positions</span>
            </h2>
            <p
              className='text-muted-foreground mx-auto'
              style={{ color: '#9AA6B2' }}
            >
              Find your next opportunity and help us shape the future
            </p>
          </div>

          <div className='row justify-content-center'>
            <div className='col-lg-10'>
              <div className='d-flex flex-column gap-3'>
                {openPositions.map((position, index) => (
                  <div
                    key={index}
                    className='p-4 rounded-4 hover-card animate-fade-in'
                    style={{
                      background: 'rgba(255,255,255,0.03)',
                      border: '1px solid rgba(255,255,255,0.05)',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      animationDelay: `${index * 0.05}s`,
                    }}
                  >
                    <div className='d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-4'>
                      <div>
                        <div className='d-flex align-items-center gap-3 mb-2'>
                          <h3 className='h5 fw-bold mb-0'>{position.title}</h3>
                          <span
                            className='px-3 py-1 rounded-pill'
                            style={{
                              background: 'rgba(29, 160, 148, 0.1)',
                              color: '#1da094',
                              fontSize: '0.8rem',
                              border: '1px solid rgba(29, 160, 148, 0.2)',
                            }}
                          >
                            {position.department}
                          </span>
                        </div>
                        <div className='d-flex gap-4 text-muted small mb-3'>
                          <span className='d-flex align-items-center gap-2'>
                            <LuMapPin /> {position.location}
                          </span>
                          <span className='d-flex align-items-center gap-2'>
                            <LuClock /> {position.type}
                          </span>
                        </div>
                        <div className='d-flex flex-wrap gap-2'>
                          {position.tags.map((tag, i) => (
                            <span
                              key={i}
                              className='px-2 py-1 rounded'
                              style={{
                                background: 'rgba(255,255,255,0.05)',
                                color: '#9AA6B2',
                                fontSize: '0.8rem',
                              }}
                            >
                              {tag}
                            </span>
                          ))}
                        </div>
                      </div>
                      <button
                        onClick={() =>
                          window.open(
                            '/comingsoon',
                            '_blank',
                            'noopener,noreferrer',
                          )
                        }
                        className='btn d-flex align-items-center gap-2'
                        style={{
                          border: '1px solid rgba(255,255,255,0.1)',
                          color: '#fff',
                          borderRadius: '50px',
                          padding: '10px 24px',
                        }}
                      >
                        Apply Now <LuChevronRight size={16} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className='text-center mt-5'>
                <p style={{ color: '#9AA6B2', marginBottom: '1rem' }}>
                  Don't see a role that fits? We're always looking for talented
                  people.
                </p>
                <button
                  onClick={() =>
                    window.open('/comingsoon', '_blank', 'noopener,noreferrer')
                  }
                  className='btn'
                  style={{
                    marginTop: '1rem',
                    backgroundColor: 'transparent',
                    color: '#fff',
                    padding: '12px 28px',
                    borderRadius: '12px',
                    fontWeight: 600,
                    border: '1px solid rgba(255,255,255,0.2)',
                  }}
                >
                  Send Open Application
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className='py-5'>
        <div className='container'>
          <div className='text-center mb-5'>
            <h2 className='display-6 fw-bold mb-3'>
              Perks & <span style={{ color: '#1da094' }}>Benefits</span>
            </h2>
            <p
              className='text-muted-foreground mx-auto'
              style={{ color: '#9AA6B2' }}
            >
              We take care of our team so they can focus on what matters
            </p>
          </div>

          <div className='row g-4 justify-content-center'>
            {benefits.map((benefit, index) => (
              <div key={index} className='col-md-6 col-lg-4'>
                <div
                  className='p-4 rounded-4 hover-card h-100 animate-fade-in'
                  style={{
                    background:
                      'linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))',
                    border: '1px solid rgba(255,255,255,0.05)',
                    transition: 'all 0.3s ease',
                    animationDelay: `${index * 0.1}s`,
                  }}
                >
                  <div className='d-flex gap-3'>
                    <div
                      className='d-flex align-items-center justify-content-center flex-shrink-0'
                      style={{
                        width: '42px',
                        height: '42px',
                        borderRadius: '12px',
                        background: 'rgba(29, 160, 148, 0.1)',
                        color: '#1da094',
                        fontSize: '1.2rem',
                      }}
                    >
                      <benefit.icon />
                    </div>
                    <div>
                      <h3 className='h6 fw-bold mb-1'>{benefit.title}</h3>
                      <p className='small mb-0' style={{ color: '#9AA6B2' }}>
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Culture Section */}
      <section className='py-5 position-relative overflow-hidden'>
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'linear-gradient(to right, rgba(29, 160, 148, 0.05), transparent, rgba(29, 160, 148, 0.05))',
            zIndex: 0,
          }}
        />
        <div className='container position-relative z-1'>
          <div className='row align-items-center g-5'>
            <div className='col-lg-6'>
              <h2
                className='fw-bold mb-4'
                style={{ fontSize: 'clamp(2rem, 5vw, 3rem)' }}
              >
                Life at <span style={{ color: '#1da094' }}>Unitic</span>
              </h2>
              <p
                style={{
                  color: '#9AA6B2',
                  fontSize: '1.1rem',
                  marginBottom: '2rem',
                }}
              >
                We're a diverse, remote-first team spread across 20+ countries,
                united by our passion for building revolutionary financial
                technology. We value autonomy, creativity, and making a real
                impact.
              </p>
              <div className='d-flex flex-column gap-3 pt-3'>
                {[
                  'Flexible hours that respect your timezone',
                  'Regular virtual team activities and game nights',
                  'Annual company retreats in exciting locations',
                  'Open communication and flat hierarchy',
                ].map((item, i) => (
                  <div key={i} className='d-flex align-items-center gap-3'>
                    <div
                      style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        backgroundColor: '#1da094',
                      }}
                    />
                    <span style={{ color: '#E5E7EB' }}>{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className='col-lg-6'>
              <div className='row g-3'>
                <div className='col-6'>
                  <div className='d-flex flex-column gap-3'>
                    <div
                      className='rounded-4 d-flex align-items-center justify-content-center animate-float'
                      style={{
                        aspectRatio: '1/1',
                        background: 'rgba(29, 160, 148, 0.1)',
                        border: '1px solid rgba(29, 160, 148, 0.2)',
                        fontSize: '3rem',
                        animationDelay: '0s',
                      }}
                    >
                      🌍
                    </div>
                    <div
                      className='rounded-4 d-flex align-items-center justify-content-center animate-float'
                      style={{
                        aspectRatio: '4/3',
                        background: 'rgba(255,255,255,0.03)',
                        border: '1px solid rgba(255,255,255,0.05)',
                        fontSize: '3rem',
                        animationDelay: '1s',
                      }}
                    >
                      💻
                    </div>
                  </div>
                </div>
                <div className='col-6 pt-5'>
                  <div className='d-flex flex-column gap-3'>
                    <div
                      className='rounded-4 d-flex align-items-center justify-content-center animate-float'
                      style={{
                        aspectRatio: '4/3',
                        background: 'rgba(255,255,255,0.03)',
                        border: '1px solid rgba(255,255,255,0.05)',
                        fontSize: '3rem',
                        animationDelay: '2s',
                      }}
                    >
                      🚀
                    </div>
                    <div
                      className='rounded-4 d-flex align-items-center justify-content-center animate-float'
                      style={{
                        aspectRatio: '1/1',
                        background: 'rgba(29, 160, 148, 0.1)',
                        border: '1px solid rgba(29, 160, 148, 0.2)',
                        fontSize: '3rem',
                        animationDelay: '3s',
                      }}
                    >
                      🤝
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className='py-5'>
        <div className='container'>
          <div
            className='text-center p-5 rounded-5 position-relative overflow-hidden'
            style={{
              background: 'rgba(255,255,255,0.02)',
              border: '1px solid rgba(255,255,255,0.05)',
              backdropFilter: 'blur(20px)',
            }}
          >
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background:
                  'radial-gradient(circle at center, rgba(29, 160, 148, 0.1), transparent 70%)',
                zIndex: 0,
              }}
            />
            <div className='position-relative z-1'>
              <h2
                className='fw-bold mb-4'
                style={{
                  fontWeight: 800,
                  fontSize: '2.5rem',
                  marginBottom: '1rem',
                  color: '#fff',
                  lineHeight: 1.2,
                }}
              >
                Ready to Make an{' '}
                <span style={{ color: '#1da094' }}>Impact</span>?
              </h2>
              <p
                className='mx-auto mb-5'
                style={{
                  color: '#9AA6B2',
                  marginBottom: '2rem',
                  fontSize: '1.1rem',
                  maxWidth: '700px',
                }}
              >
                Join our mission to democratize finance and empower millions of
                people around the world. Your next adventure starts here.
              </p>
              <div className='d-flex flex-column flex-sm-row justify-content-center gap-3'>
                <button
                  onClick={() => {
                    const el = document.getElementById("open-positions");
                    if (el) {
                      const yOffset = -75;
                      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                      window.scrollTo({ top: y, behavior: "smooth" });
                    }
                  }}
                  className='btn d-flex align-items-center justify-content-center gap-2 py-2 py-md-3 px-3 px-md-4'
                  style={{
                    backgroundColor: '#1da094',
                    color: '#fff',
                    borderRadius: '12px',
                    fontWeight: 600,
                    fontSize: '1rem',
                    border: 'none',
                  }}
                >
                  Explore Open Roles
                  <LuArrowRight size={20} style={{ marginRight: 10 }} />
                </button>
                <a
                  href="mailto:hr@uniticexchange.com"
                  className="btn py-2 py-md-3 px-3 px-md-4"
                  style={{
                    backgroundColor: "transparent",
                    color: "#fff",
                    borderRadius: "12px",
                    fontWeight: 600,
                    fontSize: "1rem",
                    border: "1px solid rgba(255,255,255,0.2)",
                    textDecoration: "none",
                    display: "inline-block"
                  }}
                >
                  Contact HR Team
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default Career
